export const roleMap = {
  0: '审核不通过',
  1: '店员',
  2: '店长',
  3: '销售员',
};

export const tzOrderStatusMap = {
  ACCEPTED: '已接受',
  CONSUMED: '已消费',
  CANCELED: '已取消',
  ABORT: '已退款',
  NEW_ORDER: '新订单',
};

export const handleStatusMap = {
  1: '已接受',
  2: '满房拒绝',
  3: '价格变动拒绝',
  '-1': '未处理',
  4: '已取消',
};

export const settleMap = {
  1: '待审核',
  2: '审批通过',
  3: '审批拒绝',
};

export const fromMap = {
  0: '合计',
  1: '同舟',
  2: '代理通',
  3: '同程',
  4: '飞猪'
}
export const fromNameMap = {
  1: 'tzName',
  2: 'dltName',
  3: 'tcName',
  4: 'pigName'
}


// WEBPACK FOOTER //
// ./src/constant.js